import { Table } from 'components/core-ui/Table'
import s from './NoDailyReportsReport.modules.scss'
import { useMemo, useState } from 'react'
import { makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { toTableRowItems } from './serializers'
import { formatErrorMessage } from 'utils/formatting'
import { useNotification } from 'hooks'
import { getColumns, getFilters } from './helpers'
import { ExportActionIcon } from 'icons'
import {
  downloadReportCsv,
  getLegalEntitiesOptions,
  getLocationOptions,
  getWasteCategoryOptions
} from '../api'
import { NoDailyReportReportTableItem, TableState } from '../interfaces'

const NoDailyReportsReport = () => {
  const [tableItems, setTableItems] = useState<NoDailyReportReportTableItem[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [shouldResetPage, setShouldResetPage] = useState<boolean>(false)
  const [tableState, setTableState] = useState<TableState>({
    order: null,
    orderBy: null,
    tableFilters: null
  })

  const { showNotification } = useNotification()

  const toolbarActions = useMemo(
    () => [
      {
        label: 'Export Excel',
        icon: <ExportActionIcon />,
        onClick: () => {
          downloadReportCsvQuery.refetch()
        }
      }
    ],
    []
  )

  const { data: legalEntitiesOptions } = getLegalEntitiesOptions(showNotification)

  const { data: shopOptions } = getLocationOptions(showNotification)

  const { data: wasteCategoryOptions } = getWasteCategoryOptions(showNotification)

  const downloadReportCsvQuery = downloadReportCsv(
    showNotification,
    toTableGETUrl({
      url: '/waste-management-system/report/daily-report/csv',
      tableFilters: tableState.tableFilters
    })
  )

  const columns = useMemo(() => getColumns(), [])

  const filters = useMemo(
    () => getFilters(legalEntitiesOptions, shopOptions, wasteCategoryOptions),
    [shopOptions]
  )

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/waste-management-system/locations/missing-daily-reports',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableState({
        order,
        orderBy,
        tableFilters
      })

      setTableItems(toTableRowItems(response.list || []))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor pentru rapoartele zilnice. ${formatErrorMessage(
          error
        )}`,
        type: 'error'
      })
    }
  }

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        shouldResetPage={shouldResetPage}
        setShouldResetPage={setShouldResetPage}
        toolbarActions={toolbarActions}
        filters={filters}
        filtersLabel="Filtreaza"
        filtersButtonLabel="Filtreaza"
        appliedFiltersLabel="Filtre"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
      />
    </div>
  )
}

export default NoDailyReportsReport
